import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Card, Button, List, Label } from 'semantic-ui-react'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row',
  },
}

const Row = ({ field, value, color }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="medium" color={color}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const DeliveryFeeOfferCard = ({ deliveryFeeOffer, restaurants, onEdit, onDelete }) => {
  const active = deliveryFeeOffer.active ? 'Yes' : 'No'
  const activeColor = deliveryFeeOffer.active ? 'green' : 'red'

  const smallOrderFee = deliveryFeeOffer.small_order_fee ? "Yes" : "No"
  const smallOrderFeeColor = deliveryFeeOffer.small_order_fee ? "green" : "red"

  const merchantName = _.get(restaurants, `[${deliveryFeeOffer.merchant}].name`, 'N/A')
  const branchName = _.get(restaurants, `[${deliveryFeeOffer.merchant}].branches[${deliveryFeeOffer.branch}].name`, 'N/A')
  const createdDate = moment(deliveryFeeOffer.created_at).format('DD-MMM-YYYY')

  return (
    <Card style={{ marginLeft: 30 }}>
      <Card.Content>
        <Card.Header>{merchantName}</Card.Header>
        <Card.Description>
          <span style={{ fontSize: 15 }}>{branchName}</span>
          <List divided verticalAlign="middle" style={{ marginTop: 10 }}>
            <Row field="Active" value={active} color={activeColor} />
            <Row field="Small Order Fee" value={smallOrderFee} color={smallOrderFeeColor} />
            <Row field="Delivery Discount" value={`${deliveryFeeOffer.delivery_discount} $`} />
            <Row field="Profit Margin" value={`${deliveryFeeOffer.profit_margin} %`} />
            <Row field="Created at" value={createdDate} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div style={styles.actionButton}>
          <Button color="black" onClick={onEdit} size="tiny" style={{ width: '100%' }}>
            Edit
          </Button>
          <Button color="red" onClick={onDelete} size="tiny" style={{ width: '100%' }}>
            Delete
          </Button>
        </div>
      </Card.Content>
    </Card>
  )
}

export default DeliveryFeeOfferCard



// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/deliveryFeeOfferCard.js